import React, { useState } from "react";
import PriceCard from "../../Components/userComponents/CourseDetailsComponents/PriceCard";
import EnrollModal from "../../Components/userComponents/CourseDetailsComponents/EnrollModal";
import CourseContent from "../../Components/userComponents/CourseDetailsComponents/CourseContent";
import TechSlider from "../../Components/userComponents/Common/TechSlider";
import AppointmentModal from "../../Components/userComponents/Common/AppointmentModal";

const CourseDetails = () => {
  const [open, setOpen] = useState(false);
  const handleAddOpen = () => setOpen(true);
  const handleModalClose = () => setOpen(false);

  const course = {
    title: "Full-Stack Web Development Bootcamp",
    banner:
      "https://images.prismic.io/loco-blogs/79328284-f97b-489f-924c-eb3b17e34b56_image2.png?auto=compress%2Cformat&rect=0%2C0%2C1999%2C1124&w=1920&h=1080&ar=1.91%3A1",
    short:
      "Learn HTML, CSS, JavaScript, React, Node.js, Express.js, and MongoDB to build and deploy full-stack apps.",
    price: "₹16,999",
    oldPrice: "₹20,999",
    rating: 4.8,
    students: 12345,
    duration: "12 weeks",
    level: "Beginner → Advanced",
    whatYouGet: [
      "5 Days of Technical Classes",
      "1 Day of Soft Skill Classes",
      "Live Coding Sessions",
      "Hands-on Projects",
      "Quizzes & practice exercises",
      "3-4 real-world Minor Projects",
      "2 real-world Major Projects",
      "Certificate of completion",
    ],
    courseContent: [
      {
        id: 1,
        title: "Getting Started - Web Basics",
        lessons: ["HTML fundamentals", "Semantic HTML", "Intro to CSS"],
      },
      {
        id: 2,
        title: "JavaScript Essentials",
        lessons: ["Variables & Types", "Functions & Scope", "DOM Manipulation"],
      },
      {
        id: 3,
        title: "React & State Management",
        lessons: ["Create React App", "Hooks", "Routing", "Context & Redux"],
      },
      {
        id: 4,
        title: "Backend with Node.js",
        lessons: ["Express", "REST APIs", "MongoDB basics"],
      },
    ],
    reviews: [
      {
        id: 1,
        name: "Ravi",
        text: "Great course — practical and well-structured.",
        rating: 5,
      },
      {
        id: 2,
        name: "Aahana",
        text: "Projects helped me get a job!",
        rating: 5,
      },
      {
        id: 3,
        name: "Ashish",
        text: "Clear explanations and helpful exercises.",
        rating: 4,
      },
    ],
  };

  return (
    <section className="overflow-hidden relative min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      {/* Glow blobs like hero section */}
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="absolute -right-32 -top-24 h-72 w-72 rounded-full bg-[#064585]/40 blur-3xl" />
        <div className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#5989C8]/30 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
        <div className="grid gap-8 lg:grid-cols-3">
          {/* Left column */}
          <main className="lg:col-span-2">
            <CourseContent course={course} />
          </main>

          {/* Right / Sidebar */}
          <aside className="lg:col-span-1">
            <PriceCard course={course} handleAddOpen={handleAddOpen} />
          </aside>
        </div>
      </div>

      <EnrollModal handleAddOpen={handleAddOpen} />
      <TechSlider />

      {/* Appointment Modal */}
      {open && <AppointmentModal onClose={handleModalClose} />}
    </section>
  );
};

export default CourseDetails;
